import React from "react";
import { motion } from "framer-motion";

export default function LoadingScreen() {
  return (
    <motion.div
      data-testid="loading-screen"
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center"
      style={{ background: "#070D09" }}
      exit={{ opacity: 0, scale: 1.08, transition: { duration: 0.6, ease: "easeInOut" } }}
    >
      <div className="relative">
        <motion.div
          className="relative h-36 w-36 overflow-hidden rounded-full"
          style={{ border: "1px solid rgba(212,175,55,0.4)", boxShadow: "0 0 0 rgba(212,175,55,0)" }}
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1, opacity: 1, boxShadow: "0 0 60px rgba(212,175,55,0.35), 0 0 120px rgba(16,185,129,0.2)" }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <img src="/logo-mark.png" alt="Mother Nature" className="h-full w-full object-cover" />
        </motion.div>
        <motion.div
          className="absolute inset-0 rounded-full border"
          style={{ borderColor: "rgba(212,175,55,0.35)" }}
          initial={{ scale: 1, opacity: 0.8 }}
          animate={{ scale: 1.5, opacity: 0 }}
          transition={{ duration: 1.6, delay: 0.5, repeat: Infinity, ease: "easeOut" }}
        />
      </div>
      <motion.p
        className="mt-8 font-serif text-2xl tracking-wide"
        style={{ color: "#F4F1EA" }}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.9, duration: 0.6 }}
      >
        Mother Nature
      </motion.p>
      <motion.p
        className="mt-2 font-mono text-[0.6rem] uppercase tracking-[0.4em]"
        style={{ color: "#D4AF37" }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.6 }}
      >
        Ayurvedic · Pure · Natural
      </motion.p>
    </motion.div>
  );
}
